import { AxiosError } from 'axios';

export function isForbiddenError(error: unknown): boolean {
  if (!error) return false;
  if (error instanceof AxiosError) {
    return error.response?.status === 403;
  }
  const maybe = error as { response?: { status?: number }; status?: number };
  if (maybe?.response?.status === 403) return true;
  if (maybe?.status === 403) return true;
  return false;
}
